import { ButtonVariant } from 'blaze-ui/Button/Types'
import { IconButton } from 'blaze-ui/IconButton/IconButton'
import { Icon } from 'blaze-ui/icons/Types'

interface Props {
  icon: Icon
  onPress: () => void
  variant?: ButtonVariant
  rounded?: boolean
  label?: string
}

export const TopBarButton = ({ icon, onPress, variant = 'editor', rounded = true, label }: Props) => {
  return <IconButton icon={icon} onPress={onPress} variant={variant} rounded={rounded} aria-label={label} />
}
